import Axios from "axios";

export default {

  /**
   * 列表 
   * @param {*} keyword 
   */
  listPage(
    page,
    keyword
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/account/page`, {
      params: {
        page,
        keyword
      }
    });
  },

  /**
   * 权限菜单
   */
  menuList() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/account/permission`);
  },

  /**
   * 增加
   * @param {*} account_attr_phone 
   * @param {*} permission_ids 
   * @param {*} account_status 
   */
  add(
    account_attr_phone,
    account_attr_name,
    account_attr_title,
    permission_ids,
    account_status
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/account`, {
      account_attr_phone,
      account_attr_name,
      account_attr_title,
      permission_ids,
      account_status
    });
  },

  /**
   * 编辑
   * @param {*} accountId 
   * @param {*} account_attr_phone 
   * @param {*} permission_ids 
   * @param {*} account_status 
   */
  edit(
    accountId,
    account_attr_phone,
    account_attr_name,
    account_attr_title,
    permission_ids,
    account_status
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/account/${accountId}`, {
      account_attr_phone,
      account_attr_name,
      account_attr_title,
      permission_ids,
      account_status
    });
  },

  /**
   * 删除
   * @param {*} accountId 
   */
  del(
    accountId
  ) {
    return Axios.delete(`${process.env.VUE_APP_PREFIX}/account/${accountId}`);
  },

  /**
   * 详情
   * @param {*} accountId 
   */
  info(
    accountId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/account/${accountId}`);
  },

  /**
   * 检测手机号是否存在
   * @param {*} phone 
   */
  phoneIsExist(
    phone
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/account/phone/${phone}/exist`);
  }

}